import { useMemo, useState } from "react";
import { exportVillageYojanaToPDF, exportYojanaToExcel, toIndianCurrencyDashboardCard } from "../../../MethodMaster/JSXComponentMothod";
import "../DashboardUnique.css";

const DETAIL_THEMES = ["yojna-detail-0", "yojna-detail-1", "yojna-detail-2", "yojna-detail-3", "yojna-detail-4"];
const SHIMMER_THEMES = ["shimmer-theme-0", "shimmer-theme-1", "shimmer-theme-2", "shimmer-theme-3", "shimmer-theme-4"];

const ShimmerCard = ({ themeIndex = 0 }) => {
  const theme = SHIMMER_THEMES[themeIndex % 5];
  return (
    <div className={`detail-shimmer ${theme}`}>
      <div className="wave"></div>
      <div style={{ width: "48px", height: "48px", borderRadius: "12px", marginBottom: "1rem" }}></div>
      <div style={{ width: "82%", height: "20px", borderRadius: "6px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "62%", height: "34px", borderRadius: "6px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "52%", height: "16px", borderRadius: "6px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "72%", height: "24px", borderRadius: "6px" }}></div>
    </div>
  );
};

const NoDataCard = ({ title, desc, icon = "fas fa-info-circle", themeIndex = 0 }) => {
  const theme = DETAIL_THEMES[themeIndex % 5];
  return (
    <div className={`govdash-noDataCard ${theme}`}>
      <i className={`govdash-icon ${icon}`}></i>
      <div className="no-data-title">{title}</div>
      <div className="no-data-desc">{desc}</div>
    </div>
  );
};

export default function VillageWiseYojanaDetails({ VillageWiseYojanaData, selVillage, setSelVillageYojna, fetchingVillageWiseYojana }) {
  const [searchUsed, setSearchUsed] = useState("");
  const [searchNotUsed, setSearchNotUsed] = useState("");

  const data = VillageWiseYojanaData?.[0] ?? {};
  const used = data.UsedYojna ?? [];
  const notUsed = data.NotUsedYojna ?? [];

  const totalLabharthi = used.reduce((sum, y) => sum + (y.BeneficialCount || 0), 0);

  const filteredUsed = useMemo(() => {
    if (!searchUsed.trim()) return used;
    return used.filter((y) => y.GramYojnaName?.toLowerCase().includes(searchUsed.toLowerCase()));
  }, [used, searchUsed]);

  const filteredNotUsed = useMemo(() => {
    if (!searchNotUsed.trim()) return notUsed;
    return notUsed.filter((y) => y.GramYojnaName?.toLowerCase().includes(searchNotUsed.toLowerCase()));
  }, [notUsed, searchNotUsed]);

  const handleExcelExport = () => {
    const villageName = selVillage?.VillageNameEnglish || "Unknown Village";

    const exportData = [
      {
        A: `ગામનું નામ: ${villageName}`,
        B: "",
        C: "",
        D: "",
      },
      {
        A: `કુલ વસ્તી : ${selVillage.VillageVoterCount.toLocaleString()} | કુલ લાભાર્થી : ${selVillage?.BeneficialCount?.toLocaleString()} | કુલ લાભાર્થી લાભ : ${selVillage?.TotalLabharthiLabh?.toLocaleString()} | કુલ રકમ : ${selVillage?.TotalAmount?.toLocaleString()}`,
        B: "",
        C: "",
        D: "",
      },
      {
        A: "યોજનાનું નામ",
        B: "લાભાર્થીઓની સંખ્યા",
        C: "રકમ",
        D: "સમયગાળો",
      },
    ];

    [...used, ...notUsed].forEach((yojana) => {
      // const labharthi = Number(yojana.BeneficialCount) || 0;
      // const totalAmt = Number(yojana.TotalAmount) || 0;
      // const amt = Number(yojana.Amount) || 0;
      // const timePeriod = yojana.TimePeriod || 1;
      // const suffix = timePeriod == 12 ? "દર માસ" : "દર વર્ષે";
      // let amountText = "-";

      // if (totalAmt > 0 && labharthi > 0) {
      //   amountText = `${labharthi.toLocaleString()} × ₹${totalAmt} = ₹${labharthi * totalAmt}`;
      // } else if (labharthi > 0) {
      //   amountText = `Labharthi : ${labharthi.toLocaleString()}`;
      // }

      // exportData.push({
      //   A: yojana.GramYojnaName || "",
      //   B: labharthi.toLocaleString(),
      //   C: amountText,
      //   D: (totalAmt > 0 && labharthi > 0) || labharthi > 0 ? suffix : "-",
      // });

      const yojanaAmounts = yojana?.YojnaAmounts?.[0];

      const timePeriod = yojana.TimePeriod || 1;
      const suffix = timePeriod == 12 ? "દર માસ" : "દર વર્ષે";

      let labharthi = 0;
      let totalAmt = 0;
      let amountText = "-";

      if (yojanaAmounts) {
        labharthi = Number(yojanaAmounts?.BeneficialCount) || 0;
        totalAmt = Number(yojanaAmounts?.Amount) || 0;

        if (labharthi > 0 && totalAmt > 0) {
          amountText = `${labharthi.toLocaleString()} × ₹${totalAmt.toLocaleString()} = ₹${(labharthi * totalAmt).toLocaleString()}`;
        } else {
          amountText = "-";
        }
      } else {
        labharthi = Number(yojana?.BeneficialCount) || 0;
        totalAmt = Number(yojana?.TotalAmount) || 0;

        if (labharthi > 0 && totalAmt > 0) {
          amountText = `₹${totalAmt.toLocaleString()}`;
        } else if (labharthi > 0) {
          amountText = `Labharthi : ${labharthi.toLocaleString()}`;
        }
      }

      exportData.push({
        A: yojana.GramYojnaName || "",
        B: labharthi ? labharthi.toLocaleString() : "-",
        C: amountText,
        D: amountText !== "-" ? suffix : "-",
      });
    });

    exportYojanaToExcel(exportData, `${villageName}_Yojana_Report`);
  };

  const handlePDFExport = () => {
    const villageName = selVillage?.VillageNameEnglish || "Unknown Village";
    const exportData = [
      { "Yojana Name": `ગામનું નામ: ${villageName}`, Amount: "" },
      { "Yojana Name": `કુલ વસ્તી : Null | કુલ લાભાર્થી : ${selVillage.BeneficialCount.toLocaleString()} | કુલ રકમ : ${selVillage?.TotalAmount?.toLocaleString()}`, Amount: "" },
      { "Yojana Name": "", Amount: "" },
      { "Yojana Name": "Yojana Name", Amount: "Amount" },
    ];

    [...used, ...notUsed].forEach((yojana) => {
      const labharthi = yojana.BeneficialCount || 0;
      const totalAmt = Number(yojana.TotalAmount) || 0;
      const timePeriod = yojana.TimePeriod || 1;
      const suffix = timePeriod == 12 ? "(દર માસ)" : "(દર વર્ષે)";
      let amountText = "-";

      if (totalAmt > 0 && labharthi > 0) {
        const perPerson = totalAmt / labharthi;
        const formattedPer = perPerson.toLocaleString("en-IN", { maximumFractionDigits: 0 });
        const formattedTotal = totalAmt.toLocaleString("en-IN");
        amountText = `${labharthi.toLocaleString()}\n${labharthi.toLocaleString()} × ₹${formattedPer} = ₹${formattedTotal}\n${suffix}`;
      } else if (labharthi > 0) {
        amountText = `Labharthi : ${labharthi.toLocaleString()}`;
      }

      exportData.push({
        "Yojana Name": yojana.GramYojnaName || "",
        Amount: amountText,
      });
    });

    exportVillageYojanaToPDF(exportData, `${villageName}_Yojana_Report`);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
        <h2 className="govdash-sectionTitle m-0">{selVillage?.VillageNameEnglish} - Yojana Details</h2>
        {/* Desktop Excel Button */}
        <div className="d-none d-md-flex gap-2">
          <div>
            <button onClick={handleExcelExport} className="govdash-excelBtn mt-4">
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
        </div>
      </div>

      <div className="govdash-used mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3 mt-3 mt-md-0">
          <div className="d-flex align-items-center gap-3">
            <div className="govdash-sectionTitle">Used Yojanas</div>
            <div className="govdash-countBadgeSimple">{used.length}</div>
          </div>
          {/* Desktop Search */}
          <div className="govdash-searchWrapper d-none d-md-flex">
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search Used Yojana..." value={searchUsed} onChange={(e) => setSearchUsed(e.target.value)} className="govdash-searchInput" />
            {searchUsed && (
              <button onClick={() => setSearchUsed("")} className="govdash-clearSearch">
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
        </div>

        {/* Mobile Combined Search & Excel */}
        <div className="d-flex d-md-none gap-2 mb-3 w-100">
          <div className="govdash-searchWrapper flex-grow-1">
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search Used Yojana..." value={searchUsed} onChange={(e) => setSearchUsed(e.target.value)} className="govdash-searchInput w-100" />
            {searchUsed && (
              <button onClick={() => setSearchUsed("")} className="govdash-clearSearch">
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
          <button onClick={handleExcelExport} className="govdash-excelBtn mt-0">
            <i className="fas fa-file-excel"></i> Export Excel
          </button>
        </div>

        <div className="govdash-grid6">
          {fetchingVillageWiseYojana ? (
            Array(12)
              .fill()
              .map((_, i) => <ShimmerCard key={`used-${i}`} themeIndex={i} />)
          ) : filteredUsed.length > 0 ? (
            filteredUsed.map((y, i) => {
              const theme = DETAIL_THEMES[i % 5];
              return (
                <div key={y.yid} className={`govdash-yojnaCard ${theme}`} onClick={() => setSelVillageYojna({ yojna: y, village: selVillage })}>
                  <i className={`govdash-icon ${y.IconName ?? "fas fa-check-circle"}`}></i>
                  <div className="govdash-yojnaName">{y.GramYojnaName}</div>
                  <div className="govdash-labharti">{y.BeneficialCount?.toLocaleString()}</div>
                  <div style={{ fontSize: "0.9rem", color: "#64748b" }}>Labharthi</div>
                  {/* {y.TotalAmount ? <div className="govdash-amount">₹{y.TotalAmount.toLocaleString()}</div> : ""} */}
                  {y.TotalAmount ? <div className="govdash-amount">{toIndianCurrencyDashboardCard(y?.TotalAmount)}</div> : ""}
                  <span className="govdash-statusBadge govdash-active">Used</span>
                </div>
              );
            })
          ) : (
            <NoDataCard
              title={searchUsed ? "No Matching Used Yojana" : "No Used Yojanas"}
              desc={searchUsed ? "Try different keywords" : "This village has not utilized any schemes yet."}
              icon="fas fa-search"
              themeIndex={0}
            />
          )}
        </div>
      </div>

      <div className="govdash-unused">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-3">
            <div className="govdash-sectionTitleNotUsed">Not Used Yojanas</div>
            <div className="govdash-countBadgeSimple ">{notUsed.length}</div>
          </div>
          <div className="govdash-searchWrapper">
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search Not Used Yojana..." value={searchNotUsed} onChange={(e) => setSearchNotUsed(e.target.value)} className="govdash-searchInput" />
            {searchNotUsed && (
              <button onClick={() => setSearchNotUsed("")} className="govdash-clearSearch">
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
        </div>

        <div className="govdash-grid6">
          {fetchingVillageWiseYojana ? (
            Array(12)
              .fill()
              .map((_, i) => <ShimmerCard key={`unused-${i}`} themeIndex={i} />)
          ) : filteredNotUsed.length > 0 ? (
            filteredNotUsed.map((y, i) => {
              const theme = DETAIL_THEMES[i % 5];
              return (
                <div key={y.yid} className={`govdash-yojnaCard govdash-unusedCard ${theme}`}>
                  <i className={`govdash-icon ${y.IconName ?? "fas fa-times-circle"}`}></i>
                  <div className="govdash-yojnaName">{y.GramYojnaName}</div>
                </div>
              );
            })
          ) : (
            <NoDataCard
              title={searchNotUsed ? "No Matching Not Used Yojana" : "All Yojanas Used!"}
              desc={searchNotUsed ? "Try different keywords" : "Great! This village has utilized every available scheme."}
              icon="fas fa-trophy"
              themeIndex={2}
            />
          )}
        </div>
      </div>
    </>
  );
}
